import { Store } from 'vuex'
import { getModule } from 'vuex-module-decorators'

// State
import Notices from '@/store/apis/Notices'
import MonthlyCheck from '@/store/apis/MonthlyCheck'
import Monthlist from '@/store/apis/Monthlist'
import MemberName from '@/store/apis/MemberName'

import Learn from '@/store/apis/Learn'
import LearnPage from '@/store/pages/Learn'
import LearnResult from '@/store/apis/Result'
import Unit from '@/store/apis/Unit'
import ReviewContentListModal from '@/store/apis/ReviewContentListModal'
import Sample from '@/store/apis/Sample'
import ContractCoursePlan from '@/store/apis/ContractCoursePlan'
import ContractInformation from '@/store/apis/ContractInformation'
import AbilityTest from '@/store/apis/AbilityTest'
import Puchipo from '@/store/apis/Puchipo'
import Lab from '@/store/apis/Lab'
import TopContent from '@/store/apis/TopContent'
import ChrMessage from '@/store/apis/ChrMessage'
import OnlineSpeakingSSO from '@/store/apis/OnlineSpeakingSSO'
import NewNotices from '@/store/apis/NewNotices'
import ScheduleForThisMonth from '@/store/apis/ScheduleForThisMonth'

import MonthlyTest from '@/store/apis/MonthlyTest'
import Calendar from '@/store/apis/Calendar'
import Viewer from '@/store/apis/Viewer'
import DetermineSchoolSubject from '@/store/apis/DetermineSchoolSubject'
import SchoolOfChoice from '@/store/apis/schoolOfChoice'
import DetermineSchool from '@/store/apis/DetermineSchool'
import DetermineSchoolRanking from '@/store/apis/DetermineSchoolRanking'
import DiagnoseSchool from '@/store/apis/DiagnoseSchool'
import Answer from '@/store/apis/Answer'
import AnalysisReport from '@/store/apis/AnalysisReport'
import DiagnoseSchoolRanking from '@/store/apis/diagnoseSchoolRanking'
import FixationLevel from '@/store/apis/FixationLevel'
import DiagnoseSchoolSubject from '@/store/apis/DiagnoseSchoolSubject'
import AkamaiToken from '@/store/apis/AkamaiToken'
import CmsToken from '@/store/apis/CmsToken'

import ATR from '@/store/apis/ATR'
import FetchRevision from '@/store/apis/FetchRevision'

import FullDigital from '@/store/apis/FullDigital'
import FullDigitalTeishutsu from '@/store/apis/FullDigitalTeishutsu'

import AssignmentTest from '@/store/apis/AssignmentTest'
import Contractors from '@/store/apis/Contractors'
import IdToken from '@/store/apis/IdToken'
import LoginHistory from '@/store/apis/LoginHistory'

import OnlineSpeakingSSOOneTimeKey from '@/store/apis/OnlineSpeakingSSOOneTimeKey'

// eslint-disable-next-line import/no-mutable-exports
let notices: Notices

// eslint-disable-next-line import/no-mutable-exports
let monthlyCheck: MonthlyCheck

// eslint-disable-next-line import/no-mutable-exports
let monthlist: Monthlist

// eslint-disable-next-line import/no-mutable-exports
let memberName: MemberName

// eslint-disable-next-line import/no-mutable-exports
let result: LearnResult

// eslint-disable-next-line import/no-mutable-exports
let sample: Sample

// eslint-disable-next-line import/no-mutable-exports
let contractCoursePlan: ContractCoursePlan

// eslint-disable-next-line import/no-mutable-exports
let contractInformation: ContractInformation

// eslint-disable-next-line import/no-mutable-exports
let topContent: TopContent

// eslint-disable-next-line import/no-mutable-exports
let chrMessage: ChrMessage

// eslint-disable-next-line import/no-mutable-exports
let onlineSpeakingSSO: OnlineSpeakingSSO

// eslint-disable-next-line import/no-mutable-exports
let newNotices: NewNotices

// eslint-disable-next-line import/no-mutable-exports
let scheduleForThisMonth: ScheduleForThisMonth

// eslint-disable-next-line import/no-mutable-exports
let unit: Unit

// eslint-disable-next-line import/no-mutable-exports
let abilityTest: AbilityTest

// eslint-disable-next-line import/no-mutable-exports
let assignmentTest: AssignmentTest

// eslint-disable-next-line import/no-mutable-exports
let reviewContentListModal: ReviewContentListModal

// eslint-disable-next-line import/no-mutable-exports
let puchipo: Puchipo

// eslint-disable-next-line import/no-mutable-exports
let lab: Lab

// eslint-disable-next-line import/no-mutable-exports
let learn: Learn
// eslint-disable-next-line import/no-mutable-exports
let learnPage: LearnPage

// eslint-disable-next-line import/no-mutable-exports
let calendar: Calendar

// eslint-disable-next-line import/no-mutable-exports
let viewer: Viewer

// eslint-disable-next-line import/no-mutable-exports
let determineSchoolSubject: DetermineSchoolSubject

// eslint-disable-next-line import/no-mutable-exports
let determineSchoolRanking: DetermineSchoolRanking

// eslint-disable-next-line import/no-mutable-exports
let diagnoseSchool: DiagnoseSchool

// eslint-disable-next-line import/no-mutable-exports
let monthlyTest: MonthlyTest

// eslint-disable-next-line import/no-mutable-exports
let schoolOfChoice: SchoolOfChoice

// eslint-disable-next-line import/no-mutable-exports
let answer: Answer

// eslint-disable-next-line import/no-mutable-exports
let analysisReport: AnalysisReport

// eslint-disable-next-line import/no-mutable-exports
let diagnoseSchoolRanking: DiagnoseSchoolRanking

// eslint-disable-next-line import/no-mutable-exports
let fixationLevel: FixationLevel

// eslint-disable-next-line import/no-mutable-exports
let diagnoseSchoolSubject: DiagnoseSchoolSubject

// eslint-disable-next-line import/no-mutable-exports
let determineSchool: DetermineSchool

// eslint-disable-next-line import/no-mutable-exports
let akamaiToken: AkamaiToken

// eslint-disable-next-line import/no-mutable-exports
let cmsToken: CmsToken

// eslint-disable-next-line import/no-mutable-exports
let atr: ATR

// eslint-disable-next-line import/no-mutable-exports
let fetchRevision: FetchRevision

// eslint-disable-next-line import/no-mutable-exports
let fullDigital: FullDigital
// eslint-disable-next-line import/no-mutable-exports
let fullDigitalTeishutsu: FullDigitalTeishutsu

// eslint-disable-next-line import/no-mutable-exports
let contractors: Contractors

// eslint-disable-next-line import/no-mutable-exports
let idToken: IdToken

// eslint-disable-next-line import/no-mutable-exports
let onlineSpeakingSSOOneTimeKey: OnlineSpeakingSSOOneTimeKey

// eslint-disable-next-line import/no-mutable-exports
let loginHistory: LoginHistory

function initializeStores(store: Store<any>): void {
  notices = getModule(Notices, store)
  monthlyCheck = getModule(MonthlyCheck, store)
  monthlist = getModule(Monthlist, store)
  memberName = getModule(MemberName, store)
  sample = getModule(Sample, store)
  contractCoursePlan = getModule(ContractCoursePlan, store)
  contractInformation = getModule(ContractInformation, store)
  topContent = getModule(TopContent, store)
  chrMessage = getModule(ChrMessage, store)
  onlineSpeakingSSO = getModule(OnlineSpeakingSSO, store)
  newNotices = getModule(NewNotices, store)
  scheduleForThisMonth = getModule(ScheduleForThisMonth, store)
  unit = getModule(Unit, store)
  reviewContentListModal = getModule(ReviewContentListModal, store)
  lab = getModule(Lab, store)
  learn = getModule(Learn, store)
  learnPage = getModule(LearnPage, store)
  result = getModule(LearnResult, store)
  abilityTest = getModule(AbilityTest, store)
  assignmentTest = getModule(AssignmentTest, store)
  puchipo = getModule(Puchipo, store)
  calendar = getModule(Calendar, store)
  viewer = getModule(Viewer, store)
  determineSchoolSubject = getModule(DetermineSchoolSubject, store)
  determineSchoolRanking = getModule(DetermineSchoolRanking, store)
  diagnoseSchool = getModule(DiagnoseSchool, store)
  monthlyTest = getModule(MonthlyTest, store)
  schoolOfChoice = getModule(SchoolOfChoice, store)
  answer = getModule(Answer, store)
  analysisReport = getModule(AnalysisReport, store)
  diagnoseSchoolRanking = getModule(DiagnoseSchoolRanking, store)
  fixationLevel = getModule(FixationLevel, store)
  diagnoseSchoolSubject = getModule(DiagnoseSchoolSubject, store)
  determineSchool = getModule(DetermineSchool, store)
  akamaiToken = getModule(AkamaiToken, store)
  cmsToken = getModule(CmsToken, store)
  atr = getModule(ATR, store)
  fetchRevision = getModule(FetchRevision, store)
  fullDigital = getModule(FullDigital, store)
  fullDigitalTeishutsu = getModule(FullDigitalTeishutsu, store)
  contractors = getModule(Contractors, store)
  idToken = getModule(IdToken, store)
  onlineSpeakingSSOOneTimeKey = getModule(OnlineSpeakingSSOOneTimeKey, store)
  loginHistory = getModule(LoginHistory, store)
}

export {
  initializeStores,
  notices,
  monthlyCheck,
  monthlist,
  memberName,
  sample,
  contractCoursePlan,
  contractInformation,
  topContent,
  chrMessage,
  onlineSpeakingSSO,
  onlineSpeakingSSOOneTimeKey,
  newNotices,
  scheduleForThisMonth,
  unit,
  reviewContentListModal,
  lab,
  learn,
  learnPage,
  result,
  abilityTest,
  assignmentTest,
  puchipo,
  calendar,
  viewer,
  determineSchoolSubject,
  determineSchoolRanking,
  diagnoseSchool,
  monthlyTest,
  schoolOfChoice,
  answer,
  analysisReport,
  diagnoseSchoolRanking,
  fixationLevel,
  diagnoseSchoolSubject,
  determineSchool,
  akamaiToken,
  cmsToken,
  atr,
  fetchRevision,
  fullDigital,
  fullDigitalTeishutsu,
  contractors,
  idToken,
  loginHistory,
}

export function clearStoreStateAll() {
  contractInformation.clear()
  contractors.clear()
  idToken.clear()
  loginHistory.clear()
  clearStoreStateExceptAuth()
  fetchRevision.clear()
}

export function clearStoreStateExceptAuth() {
  notices.clear()
  monthlyCheck.clear()
  monthlist.clear()
  memberName.clear()
  sample.clear()
  contractCoursePlan.clear()
  topContent.clear()
  chrMessage.clear()
  onlineSpeakingSSO.clear()
  onlineSpeakingSSOOneTimeKey.clear()
  newNotices.clear()
  scheduleForThisMonth.clear()
  unit.clear()
  reviewContentListModal.clear()
  lab.clear()
  learn.clear()
  learnPage.clear()
  result.clear()
  abilityTest.clear()
  assignmentTest.clear()
  puchipo.clear()
  calendar.clear()
  viewer.clear()
  determineSchoolSubject.clear()
  determineSchoolRanking.clear()
  diagnoseSchool.clear()
  monthlyTest.clear()
  schoolOfChoice.clear()
  answer.clear()
  analysisReport.clear()
  diagnoseSchoolRanking.clear()
  fixationLevel.clear()
  diagnoseSchoolSubject.clear()
  determineSchool.clear()
  akamaiToken.clear()
  atr.clear()
  fullDigital.clear()
  fullDigitalTeishutsu.clear()
}
